import noop from 'lodash/noop';
import React from 'react';
import { connect } from 'react-redux';

import * as D from '../../../deps';

import ArtistRowItemSecondText from './ArtistRowItemSecondText';

export function mapStateToProps(state: $TSFixMe, ownProps: $TSFixMe): $TSFixMe {
  const props = {};
  const annotation = ownProps.annotation;
  if (annotation) {
    // @ts-expect-error TS(2339) FIXME: Property 'imgUrl' does not exist on type '{}'.
    props.imgUrl = D.getArt(annotation, 200, state);
    // @ts-expect-error TS(2339) FIXME: Property 'isLargeText' does not exist on type '{}'... Remove this comment to see the full error message
    props.isLargeText = true;
    // @ts-expect-error TS(2339) FIXME: Property 'mainText' does not exist on type '{}'.
    props.mainText = annotation.get('name');
    const backstageUrl = annotation.get('shareableUrlPath');
    // @ts-expect-error TS(2339) FIXME: Property 'mainTextUrl' does not exist on type '{}'... Remove this comment to see the full error message
    props.mainTextUrl = backstageUrl;
    // @ts-expect-error TS(2339) FIXME: Property 'secondText' does not exist on type '{}'.
    props.secondText = <ArtistRowItemSecondText href={backstageUrl} />;
    // @ts-expect-error TS(2339) FIXME: Property 'secondTextUrl' does not exist on type '{... Remove this comment to see the full error message
    props.secondTextUrl = backstageUrl;
    // @ts-expect-error TS(2339) FIXME: Property 'isImgCircle' does not exist on type '{}'... Remove this comment to see the full error message
    props.isImgCircle = true;
    // @ts-expect-error TS(2339) FIXME: Property 'rowOnclick' does not exist on type '{}'.
    props.rowOnclick = noop;
    // @ts-expect-error TS(2339) FIXME: Property 'shouldLinkImg' does not exist on type '{... Remove this comment to see the full error message
    props.shouldLinkImg = true;
    // @ts-expect-error TS(2339) FIXME: Property 'noHover' does not exist on type '{}'.
    props.noHover = true;
  }
  return props;
}

export default connect(mapStateToProps)(D.RowItem);
